module.exports = __webpack_public_path__ + "media/styles/images/svg/pencil-white-on-white-c7390d527c77751fbbe6cfe334c66a9d.svg";